import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>Page not FOund </h1>
        </div>
    );
};

export default NotFound;